module.exports = __webpack_public_path__ + "static/media/Independent cameras_2.4cdddb35.png";